/**
 * Cryptographically secure random number generator
 * Replaces Math.random() to satisfy SonarQube S2245
 * Returns: 0.0 to 1.0 (same range as Math.random())
 */
export const secureRandom = (): number => {
  const array = new Uint32Array(1);
  globalThis.crypto.getRandomValues(array);
  return array[0] / (0xFFFFFFFF + 1);
};